import * as React from "react";
import { CommonHelper } from "../../../../../../../react-core/Helpers/CommonHelper";
import { PartLoading } from "../../../../../../../react-core/Html/PartLoading";
import { JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { PensionOption } from "../../../../../../../Wrap/Constants/Enums/Apply/PensionOption";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { DrawdownType } from "../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import { PensionContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { DrawdownIncomeReviewDetailsModel } from "../../../../../../../Wrap/Models/Models/Processes/Drawdown/DrawdownIncomeReviewDetailsModel";
import { DrawdownModel } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/DrawdownModel";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { setValueByKey } from "../../../../../../Shared/Table/Utils/TableUtils";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { OAC } from "../../../Common/AdviserCharges/Components/OAC";
import { LessThanAge, PensionHelper } from "../../../Common/Helpers/PensionHelper";
import { DrawdownCalculationAction } from "../../../Common/SIPP/DrawdownDetails/Action/DrawdownCalculationAction";
import { ProtectionInformation } from "../../../Common/SIPP/DrawdownDetails/ProtectionInformation";
import { ChooseAssetsToSell } from "../Shared/ChooseAssetsToSell";
import { ChooseAssetsToSellTable } from "../../../Common/SIPP/DrawdownDetails/ChooseAssetsToSellTable";
import { CrystallisationDetailsSection } from "../../../Common/SIPP/DrawdownDetails/CrystallisationDetails";
import { DIAC } from "../../../Common/SIPP/DrawdownDetails/DIAC";
import { DrawdownPriceLock } from "../../../Common/SIPP/DrawdownDetails/DrawdownPriceLock";
import { DrawdownTypeOption } from "../../../Common/SIPP/DrawdownDetails/DrawdownType";
import {
    getSellableAssets,
    hasEnhancedPensionProtection,
    hasEnhancedProtectionWithPclsProtection,
    hasPrimaryProtection,
    isCappedOrFlexIOrUFPLS,
    isRegualr,
    shouldRestictUfpls,
    shouldShowUfplsErrorMessage,
    showChooseAssetstoSell,
    showSwitchInvestments,
} from "../../../Common/SIPP/DrawdownDetails/Helper/DrawdownDetailHelper";
import { IllHealth } from "../../../Common/SIPP/DrawdownDetails/IllHealth";
import { LTABreakdownDetails } from "../../../Common/SIPP/DrawdownDetails/LTABreakdownDetails";
import { PensionOptions } from "../../../Common/SIPP/DrawdownDetails/PensionOptions";
import { PensionProtection } from "../../../Common/SIPP/DrawdownDetails/PensionProtection";
import { PreADayPensionDetails } from "../../../Common/SIPP/DrawdownDetails/PreADayPensionDetails";
import { RegularCrystallisation } from "../../../Common/SIPP/DrawdownDetails/RegularCrystallisation";
import { ChooseAssetsToSellFor } from "../../../Common/SIPP/DrawdownDetails/Resource/Contents";
import {
    ChooseAssetsToSellAssets,
    ChooseAssetsToSwitchAssets,
} from "../../../Common/SIPP/DrawdownDetails/Store/DrawdownCalculationStoreStatic";
import { TaxFreeLumpSumPayment } from "../../../Common/SIPP/DrawdownDetails/TaxFreeLumpSumPayment";
import { IncomeBankDetails } from "../../../Common/SIPP/IncomePaymentDetails/IncomeBankDetails";
import { CalculateEstimatedPaye } from "../../../NewOneOffIncomePaymentWizard/Components/Shared/CalculateEstimatedPaye";
import { PensionBenefitsAction } from "../../Actions/PensionBenefitsAction";
import { PensionBenefitsInstructionStore } from "../../Store/Variable";
import { InvestmentPathSelection } from "../../../Common/SIPP/DrawdownDetails/InvestmentPathSelection";
import { ClientAccountStore, UserStore } from "../../../../../Stroes/Variable";
import { DeferredFundWarningMessage, drawdownDetailsMessage} from "../../../Common/Resource/Contents";
import { SwitchInvestments } from "../../../Common/SIPP/DrawdownDetails/SwitchInvestments";
import { Frequency } from "../../../../../../../Wrap/Constants/Enums/Domain/Frequency";
import { PensionSubAccountSettings } from "../../../../../../../Wrap/Models/Domains/SubAccount/PensionSubAccountSettings";
import { Action } from "../../../../../Actions/Action";
import { ChargesOnIllustration } from "../../../Common/AdviserCharges/Components/ChargesOnIlustration";
import { HistoricCrystallisationPage } from "../../../../../../../Wrap/Models/Domains/Drawdown/HistoricCrystallisationPage";
import { ITFLSAction } from "../../../TopUpWithITFLSWizard/Actions/ITFLSAction";
import { BuyAction } from "../../../Buy/Action/BuyAction";
import { ClientTradableInvestments } from "../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/ClientTradableInvestments";
import { ProductType } from "../../../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { SecurityType } from "../../../../../../../Wrap/Constants/Enums/Domain/Instrument/SecurityType";
import { AllowanceDetails } from "../../../Common/SIPP/DrawdownDetails/AllowanceDetails";
import { PCLSSection } from "../../../Common/SIPP/DrawdownDetails/PCLSSection";
import { PensionArrangementAction } from "../../../PortfolioDashboard/Components/ProductOverview/Action/PensionArrangementValuationAction";
import { PensionArrangementType } from "../../../../../../../Wrap/Constants/Enums/Domain/PensionArrangementType";
import { User } from "../../../../../../../Wrap/Models/Models/User/User";
import { PensionEstimatedPayQuery } from "../../../../../../../Wrap/Models/Domains/Tax/PensionEstimatedPayQuery";
import { PensionIncomeConfiguration } from "../../../../../../../Wrap/Constants/Enums/Domain/PensionIncomeConfiguration";
import { ServiceCharge } from "../../../../../../../Wrap/Models/Models/Charges/ServiceCharge";
import { PensionPathwayInvestmentOption } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/PensionPathwayInvestmentOption";
import { TableKeys } from "../../../Common/SIPP/DrawdownDetails/Resource/Constant";
import { ProductOverviewChargeAction } from "../../../PortfolioDashboard/Components/ProductOverview/Action/ProductOverviewChargeAction";
import { DrawdownPriceLockModel } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/DrawdownPriceLockModel";
import { isNullOrEmpty } from "../../../../../../../react-core/Utils/Arrays";
import { InvestmentAllocation } from "../../../../../../../Wrap/Models/Domains/Investment/InvestmentAllocation";

interface IPensionBenefitsDetailsProps extends IProcessComponentProps {
    type: SubAccountType;
    data: PensionContributionModel;
    hasCashIsa?: boolean;
    customerId?: number;
}

interface IPensionBenefitsDetailsState {
    assets: ChooseAssetsToSellAssets[];
    assetsToSwitchTable: ChooseAssetsToSwitchAssets[];
    isLoading: boolean;
    originType: DrawdownType;
    incomeReviewDetails: DrawdownIncomeReviewDetailsModel;
    minimumDate_DisinvestNeed?: Date;
    minimumDate_DisinvestNoNeed?: Date;
    isDisinvest: Boolean;
    pensionSubAccountSettings: PensionSubAccountSettings;
    TailoreddrawdownPermittable: boolean;
    historicCrystallisation: HistoricCrystallisationPage;
    isBlockWiazrd: boolean;
    hasDrawdownArrangement?: boolean;
    userInfo: User;
    isAcrossAllAssets: boolean;
}

export class PensionBenefitsDetails extends ProcessComponent<
    IPensionBenefitsDetailsProps,
    IPensionBenefitsDetailsState
> {
    private didInitialCalculation: boolean = false;

    constructor(props: any) {
        super(props);
        this.state = {
            assets: [],
            assetsToSwitchTable: [],
            isLoading: false,
            originType: null,
            incomeReviewDetails: null,
            isDisinvest: true,
            pensionSubAccountSettings: {},
            historicCrystallisation: null,
            TailoreddrawdownPermittable: false,
            isBlockWiazrd: false,
            hasDrawdownArrangement: false,
            userInfo: UserStore.getUserInfo(),
            isAcrossAllAssets: true,
        };
    }

    isValid() {
        if (this.props.data?.Contribution?.DrawdownModel?.PreADay) {
            this.props.showErrorMsgPopUp(["Cancel the process unless select 'No' for Pre-A-Day pension details"]);
        }
        if (!this.props.data?.Contribution?.DrawdownModel?.InstructionId) {
            this.props.showErrorMsgPopUp(["Cancel the process unless as the client does not have ill health"]);
            return false;
        }
        var isNotFirstCrystallisation = this.state?.historicCrystallisation?.TotalRows > 0;
        if (this.props.data?.Contribution?.DrawdownModel?.PensionOption != PensionOption.UFPLS
            && !this.props.data?.Contribution?.DrawdownModel?.InvestmentPathwayAnswers?.PersonalRecommendation
            && !isNotFirstCrystallisation
            && !UserStore.getUserInfo().IsInternalUser) {
            this.props.showErrorMsgPopUp(["To continue, you must have given financial advice."]);
            return false;
        }
        if (this.state.originType == DrawdownType.Flexible) {
            this.updateDrawdownIncomeReviewDetails();
        }
        
        if (this.state.TailoreddrawdownPermittable == false && this.state.originType == DrawdownType.Regular) {
            return false;
        }

        if (
            this.props.data?.Contribution?.DrawdownModel?.PensionOption == PensionOption.Drawdown &&
            this.props.data?.Contribution?.DrawdownModel?.DrawdownCalculations?.HasStopWarning
        ) {
            return false;
        }
        if (
            this.props.data?.Contribution?.DrawdownModel?.PensionOption == PensionOption.Drawdown &&
            this.props.data?.Contribution?.DrawdownModel?.DrawdownCalculations?.HasFailedStandaloneLumpSumValidation
        ) {
            return false;
        }

        if (
            this.props.data?.Contribution?.DrawdownModel?.PensionOption == PensionOption.UFPLS &&
            this.props.data?.Contribution?.DrawdownModel?.UfplsWithdrawal?.WithdrawalAmount >
            this.props.data?.Contribution?.DrawdownModel?.DrawdownCalculations?.AvailableCash
        ) {
            return false;
        }

        if (this.props.data?.Contribution?.DrawdownModel?.PensionOption == PensionOption.UFPLS
            &&
            (shouldShowUfplsErrorMessage(this.props.data?.Contribution?.PensionProtection, this.props.data?.Contribution?.DrawdownModel)
                || shouldRestictUfpls(this.props.data?.Contribution?.PensionProtection, this.props.data?.Contribution?.DrawdownModel)
            )
        ) {
            this.props.showErrorMsgPopUp(["Can not select Uncrystallised funds pension lump sum option"]);
            return false;
        }

        return (
            super.isValid() && this.props.data?.Contribution?.DrawdownModel?.PreADay == false
        );
    }

    private getProps = (key) => {
        const { onChange, data, showErrorMsgPopUp } = this.props;
        const { DrawdownModel } = data.Contribution;
        if (DrawdownModel?.ChargesExtraInfo) {
            data.Contribution.ChargesExtraInfo = DrawdownModel.ChargesExtraInfo;
        }

        return {
            data: data[key],
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: (msg, isShow) => showErrorMsgPopUp(msg, isShow),
            onChange: (changes) => this.onDataChange(onChange, changes, data, key),
        };
    };

    private getComponentProps = (data: PensionContributionModel, onChange) => {
        return {
            data: data?.Contribution?.DrawdownModel,
            onChange: (v) => {
                this.onDataChange(
                    (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                    v,
                    data.Contribution,
                    "DrawdownModel"
                );
            },
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: this.props.showErrorMsgPopUp,
            isReview: this.props.isReview,
            hierarchyId: getQueryParameters()["subaccounthierarchyid"]
        };
    };

    private getSellableAssets = () => {
        getSellableAssets(
            this.props.type,
            getQueryParameters()["hierarchyid"],
            getQueryParameters()["subaccounthierarchyid"],
            (data) => {
                this.setState({ assets: data.assetsToSell });
                this.setState({ assetsToSwitchTable: data.assetsToSwitch });
            }
        );
    };

    private checkDeferredFunds(assets) {
        let deferredInstrumentCodes = assets.filter((a) => a.IsDeferred).map((o) => o.Assets);
        let message = DeferredFundWarningMessage.CannotSwitchFromDeferredFundWarning.replace(
            "<InstrumentCode>",
            deferredInstrumentCodes.join(",")
        );
        this.props.showErrorMsgPopUp([message]);
    }

    componentDidMount() {
        super.componentDidMount();
        this.getSellableAssets();

        if (!(this.props.data?.Contribution?.AdviceGiven) && this.props.data?.Contribution?.DrawdownModel?.InvestmentPathwayAnswers?.PersonalRecommendation == null) {
            this.handleAdviceGiven(true)
        }

        if (
            !this.ageNeedIllHealth(this.props.data) &&
            !this.props.data?.Contribution?.DrawdownModel?.InstructionId
        ) {
            this.createAndLoadDrawdownInstruction(this.props.data);
        }

        this.setMinimumDateDisinvestState();
        this.setInitialOriginType(this.props.data.Contribution?.DrawdownModel?.DrawdownType);
        if (this.props.data.Contribution?.DrawdownModel?.DrawdownType == DrawdownType.Flexible) {
            this.getDrawdownIncomeReviewDetails();
        }

        this.getPensionData();
        ITFLSAction.getHistoricCrystallisation(
            this.props.data.Contribution.ExistingPensionSubAccountHierarchyId,
            (result) => {
                this.setState({ historicCrystallisation: result });
            }
        );
        const params = getQueryParameters();
        BuyAction.getReuseHoldings(
            params["hierarchyid"],
            params["subaccounthierarchyid"],
            0,
            (data: ClientTradableInvestments) => {
                const result = data.CurrentIndividualHoldings.filter(
                    (ele) =>
                        ele.CurrQuantity > 0 &&
                        ele.MarketValue?.Amount > 0 &&
                        ele.SecurityType == SecurityType.OffPlatform
                ).every((ele) => ele.Permittailoreddrawdown == true);
                this.setState({ TailoreddrawdownPermittable: result });
            }
        );
        if (this.props.type == SubAccountType.Npr) {
            PensionArrangementAction.GetPensionArrangementDetails(this.props.data.Contribution.ExistingPensionSubAccountHierarchyId, true, (v) => {
                this.setDrawdownArrangement(v);
            });
        }

        const assets = this.props.data.Contribution?.DrawdownModel?.PensionCommencementLumpSumAllocations;
        if (!isNullOrEmpty(assets)) {
            this.setState({ isAcrossAllAssets: false });
        }
    }

    private setDrawdownArrangement(arrangementDetails) {
        arrangementDetails.forEach(v => {
            if (v.Type != PensionArrangementType.Accumulation) {
                this.setState({ hasDrawdownArrangement: true });
            }
        });
    }

    componentDidUpdate(prevProps: any): void {
        super.componentDidUpdate(prevProps);

        if (
            this.props.data?.Contribution?.DrawdownModel?.IsAcrossAllAssets != undefined &&
            prevProps.data?.Contribution?.DrawdownModel?.IsAcrossAllAssets !=
            this.props.data?.Contribution?.DrawdownModel?.IsAcrossAllAssets
        ) {
            this.setIsDisinvest();
        }

        if (
            prevProps?.data?.Contribution?.DrawdownModel?.DrawdownType &&
            (prevProps?.data?.Contribution?.DrawdownModel?.DrawdownType !=
                this.props.data?.Contribution?.DrawdownModel?.DrawdownType)
        ) {
            this.doCalculation();
        }

        if (this.props.data?.Contribution?.DrawdownModel?.CrystallisationDetails?.CrystallisationOption
            && !this.didInitialCalculation) {
            this.doCalculation();
            this.didInitialCalculation = true;
        }

        if (
            JSON.stringify(prevProps.data?.Contribution?.DrawdownModel) !==
            JSON.stringify(this.props.data?.Contribution?.DrawdownModel)) {
            this.updatePensionCommencementLumpSumAllocations();
        }

        if (prevProps?.data?.Contribution?.DrawdownModel?.AllowanceDetails == null && 
            this.props.data?.Contribution?.DrawdownModel?.AllowanceDetails != null
        ) {
            this.updateBCEsDetails();
        }
        
        if (this.props.data?.Contribution?.PensionProtection?.TransitionalLumpSum?.HasProtection && 
            (prevProps?.data?.Contribution?.PensionProtection?.TransitionalLumpSum?.HasProtection !=
                this.props.data?.Contribution?.PensionProtection?.TransitionalLumpSum?.HasProtection)
        ) {
            this.updateBCEsDetails();
        }

        if (
            this.props.data?.Contribution?.DrawdownModel?.InvestmentPathwayAnswers?.InvestmentOption == PensionPathwayInvestmentOption.CurrentInvestments &&
            prevProps.data?.Contribution?.DrawdownModel?.InvestmentPathwayAnswers?.InvestmentOption !== PensionPathwayInvestmentOption.CurrentInvestments
        ) {
            const currentSwitchModel = this.props.data.Contribution.DrawdownModel.SwitchInstructionModel;
            const hasAllocations = (currentSwitchModel?.BuyAllocations?.length > 0 || currentSwitchModel?.SellAllocations?.length > 0);
            const isSwitching = this.props.data.Contribution.DrawdownModel.SwitchInvestments;

            if (isSwitching || hasAllocations) {
                this.updateSwitchDetails(false, [], []);
            }
        }

        if (prevProps.data.Contribution?.DrawdownModel?.PensionCommencementLumpSumAllocations
            !== this.props.data.Contribution?.DrawdownModel?.PensionCommencementLumpSumAllocations) {
            // if IsAcrossAllAssets set to true, then allocation is calculated by backend, so list should be empty
            const assets = this.props.data.Contribution?.DrawdownModel?.PensionCommencementLumpSumAllocations;
            if (!isNullOrEmpty(assets)) {
                this.setState({ isAcrossAllAssets: false });
            }
        }
    }

    componentWillUpdate(nextProps, nextState): void {
        super.componentWillUpdate(nextProps, nextState);

        //assetsTable state change
        if (this.state.assets.length == 0 && nextState.assets.length > 0) {
            this.setIsDisinvest(nextState.assets);
        }
    }

    setInitialOriginType(type: DrawdownType) {
        if (type) {
            this.setState({ originType: type });
        }
    }

    setMinimumDateDisinvestState() {
        DrawdownCalculationAction.getMinimumPaymentDate(
            getQueryParameters()["subaccounthierarchyid"],
            true,
            true,
            (result) => {
                this.setState({
                    minimumDate_DisinvestNeed: new Date(result.MinimumDateTime),
                });
            }
        );

        DrawdownCalculationAction.getMinimumPaymentDate(
            getQueryParameters()["subaccounthierarchyid"],
            false,
            false,
            (result) => {
                this.setState({
                    minimumDate_DisinvestNoNeed: new Date(result.MinimumDateTime),
                });
            }
        );
    }

    private setIsDisinvest(assetsTable: ChooseAssetsToSellAssets[] = []) {
        let assetData = this.state.assets.length > 0 ? this.state.assets : assetsTable;
        let assetAllocations = this.props.data?.Contribution?.DrawdownModel?.PensionCommencementLumpSumAllocations;
        let isAcrossAllAssets = this.props.data?.Contribution?.DrawdownModel?.IsAcrossAllAssets ?? true;

        //if the asset allocation got 100% cash, then disinvestment is not needed
        if (
            (isAcrossAllAssets && assetData && assetData.length == 1) ||
            (!isAcrossAllAssets &&
                assetAllocations &&
                assetData &&
                assetData.some(
                    (x) =>
                        x.Assets.toUpperCase() == "GBP CASH" &&
                        assetAllocations.some((y) => y.ProductId == x.Id && y.Percentage == 100)
                ))
        ) {
            this.setState({
                isDisinvest: false,
            });
            return;
        }

        this.setState({
            isDisinvest: true,
        });
    }

    private doCalculation = () => {
        this.setState({ isLoading: true }, () => {
            const originType =
                this.state.originType ||
                PensionBenefitsInstructionStore.getData()?.Contribution?.DrawdownModel?.DrawdownType;
            const currType = this.props.data?.Contribution?.DrawdownModel?.DrawdownType;
            const _data = JSON.parse(JSON.stringify(this.props.data));
            this.setState({ originType: currType });
            const originIsRegular = originType == DrawdownType.Regular;
            const currIsRegular = currType == DrawdownType.Regular;

            if (_data?.Contribution?.DrawdownModel) {
                _data.Contribution.DrawdownModel.ChangeInstructionType =
                    (originIsRegular && !currIsRegular) || (!originIsRegular && currIsRegular);
            }

            PensionBenefitsAction.doCalculation(_data, () => {
                this.setState({ isLoading: false });
            })
        });

    };

    private needIllHealth(data: PensionContributionModel) {
        return (
            this.ageNeedIllHealth(data) &&
            !data?.Contribution?.DrawdownModel?.InstructionId
        );
    }

    private ageNeedIllHealth(data: PensionContributionModel) {
        return data?.Contribution?.PensionProtection?.PensionSchemeSpecificProtection?.ProtectedRetirementAge
            ? false
            : LessThanAge(55, JsonDateParser.toDate(data?.ClientDetails?.DateOfBirth));
    }

    private getDrawdownIncomeReviewDetails() {
        const account = ClientAccountStore.getActiveClientSubAccounts();
        const hierarchyId = account.find((x) => x.SubAccountType == SubAccountType.Npr).HierarchyId;

        PensionBenefitsAction.getDrawdownIncomeReviewDetails(hierarchyId, (val) => {
            this.setState({
                incomeReviewDetails: val,
            });
        });
    }

    private updateDrawdownIncomeReviewDetails() {
        const model = this.state.incomeReviewDetails;
        if (model?.DrawdownIncomeReviewDetails) {
            PensionBenefitsAction.updateDrawdownIncomeReviewDetails(model);
        }
    }

    private createAndLoadDrawdownInstruction(data: PensionContributionModel, isIllHealth: boolean = false) {
        this.setState({ isLoading: true });

        DrawdownCalculationAction.postDrawdown(
            this.props.data?.Contribution?.HierarchyId,
            null,
            (drawdownModel: DrawdownModel) => {
                const hierarchyId = getQueryParameters()["hierarchyid"];
                const account = ClientAccountStore.getClientAccountInfo();
                const subAccountHierarchyId = account.SubAccounts.find((x) => x.SubAccountType == SubAccountType.Npr)
                    .HierarchyId;
                const type = Number(getQueryParameters()["type"]);

                PensionBenefitsAction.getInstruction(
                    data?.Contribution?.HierarchyId,
                    type,
                    hierarchyId,
                    subAccountHierarchyId,
                    this.props.customerId,
                    () => {
                        this.setState({ isLoading: false, originType: drawdownModel?.DrawdownType });

                        if (drawdownModel?.DrawdownType == DrawdownType.Flexible) {
                            this.getDrawdownIncomeReviewDetails();
                        }
                    }
                );
            },
            isIllHealth,
            true,
        );
    }

    private getPensionData(): void {
        const hierarchyId = getQueryParameters()["subaccounthierarchyid"];
        Action.getPensionSubAccountSettings(hierarchyId, false, (val) => {
            this.setState({
                pensionSubAccountSettings: val,
            });
        });
    }

    private updatePensionCommencementLumpSumAllocations() {
        const { data } = this.props;
        const drawdownModel = data?.Contribution?.DrawdownModel;
        if (!drawdownModel || drawdownModel.DrawdownType == DrawdownType.Regular) return;
        if (!this.state.assets || this.state.assets.length === 0) return;

        const cashAsset = this.state.assets.find(a => a.Assets.toUpperCase() === "GBP CASH");
        if (!cashAsset) return;

        if (!showChooseAssetstoSell(drawdownModel, ChooseAssetsToSellFor.Drawdown)) {
            const pclsAllocations = [{
                ProductId: cashAsset.Id,
                Name: cashAsset.Assets,
                Percentage: 100,
                Type: cashAsset.ProductType
            }];

            const changes = {
                PensionCommencementLumpSumAllocations: pclsAllocations
            };

            this.onDataChange(
                (changeData) => this.onDataChange(this.props.onChange, changeData, data, "Contribution"),
                changes,
                this.props.data.Contribution,
                "DrawdownModel"
            );
        }
    }
    
    private updateBCEsDetails(){
        if (this.props.data?.Contribution?.DrawdownModel?.AllowanceDetails &&
            this.props.data?.Contribution?.PensionProtection?.TransitionalLumpSum?.HasProtection
        ) {
            this.onDataChange(
                (changes) => this.onDataChange(this.props.onChange, changes, this.props.data, "Contribution"),
                { 
                    AllowanceDetails: {
                        ...this.props.data.Contribution.DrawdownModel.AllowanceDetails,
                        HasOffPlatformBcePriorApril2024: true,
                        AwareOfBCEAmounts: true
                    } 
                },
                this.props.data.Contribution,
                "DrawdownModel"
            );
        }
    }

    private updateSwitchDetails(switchFlag: boolean, buyAllocations: any[] = [], sellAllocations: any[] = []) {
        const { data, onChange } = this.props;
        this.onDataChange(
            (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
            {
                SwitchInvestments: switchFlag,
                SwitchInstructionModel: {
                    ...(data.Contribution.DrawdownModel.SwitchInstructionModel || {}),
                    BuyAllocations: buyAllocations,
                    SellAllocations: sellAllocations
                }
            },
            data.Contribution,
            "DrawdownModel"
        );
    }

    private getCalculateEstimatedPayeQueries(): Array<PensionEstimatedPayQuery> {
        return [
            {
                HierarchyId: getQueryParameters()["subaccounthierarchyid"],
                PensionIncomeConfiguration: PensionIncomeConfiguration.PensionLevel,
                GrossAmount: this.props.data.Contribution.DrawdownModel.CrystallisationDetails.CrystallisationAmount,
                Frequency: Frequency.Monthly,
                PaymentDate: JsonDateParser.toJsonDate(new Date())
            }];
    }

    private handleAdviceGiven = (adviceGiven: boolean) => {
        this.onDataChange(this.props.onChange, { AdviceGiven: adviceGiven }, this.props.data, "Contribution");
    }

    private getTotalPea(drawdownModel: DrawdownModel) {
        if (this.state.assets?.length === 0) return;

        const taxFreeLumpSum = drawdownModel?.TaxFreeLumpSum?.Amount ?? 0;
        let disinvestmentPea = 0;

        if (drawdownModel?.CrystallisationDetails?.AvailableCash?.Amount < taxFreeLumpSum) {
            if (drawdownModel?.IsAcrossAllAssets) {
                const assetsAmount = this.state.assets
                    .filter((asset) => asset.ProductType !== ProductType.OffPlatform && asset.ProductType !== ProductType.Cash)
                    .reduce((total, asset) => total + asset.MarketValue.Amount, 0);

                const totalAmount = this.state.assets
                    .filter((asset) => asset.ProductType !== ProductType.OffPlatform)
                    .reduce((total, asset) => total + asset.MarketValue.Amount, 0);

                if (totalAmount > 0) {
                    disinvestmentPea = (assetsAmount / totalAmount) * taxFreeLumpSum;
                }
            } else {
                disinvestmentPea = PensionHelper.getDisinvestmentPeaTotal(drawdownModel?.PensionCommencementLumpSumAllocations, taxFreeLumpSum);
            }
        }

        return taxFreeLumpSum - disinvestmentPea;
    }

    private showChooseAssetsToSellTable() : boolean {
        return !this.state.isAcrossAllAssets;
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;
        const { originType, incomeReviewDetails, pensionSubAccountSettings, assets } = this.state;
        const isNotFirstCrystallisation = this.state?.historicCrystallisation?.TotalRows > 0;
        const ageLessThan75 = LessThanAge(75, JsonDateParser.toDate(data?.ClientDetails?.DateOfBirth));
        const hasOuterRingAssets = assets.some(x => x.ProductType === ProductType.OffPlatform);

        if (this.needIllHealth(data)) {
            return (
                <IllHealth
                    {...this.getComponentProps(data, onChange)}
                    getDrawdownModel={() => {
                        this.createAndLoadDrawdownInstruction(data, true);
                    }}
                />
            );
        }

        return (
            <PartLoading isLoading={this.state.isLoading}>
                <h2>Pension Benefits Details</h2>
                <>
                    {this.state.TailoreddrawdownPermittable == false && originType == DrawdownType.Regular && (
                        <Alert
                            alertType={AlertType.Error}
                            message={drawdownDetailsMessage.HasTailoredDrawdownErrorMessage}
                        />
                    )}
                    <PensionOptions
                        {...this.getComponentProps(data, onChange)}
                        pensionProtection={data?.Contribution?.PensionProtection}
                        clientDetail={data?.ClientDetails}
                        validateDrawdown={(d) => {
                            if (d?.DrawdownPriceLock) {
                                const hierarchyId = getQueryParameters()["subaccounthierarchyid"];
                                DrawdownCalculationAction.getEstimatedPlatformChargeRate(hierarchyId, this.getTotalPea(d), (serviceCharges: ServiceCharge[]) => {
                                    ProductOverviewChargeAction.getDrawdownPriceLock(hierarchyId, (drawdownPriceLockModel: DrawdownPriceLockModel) => {
                                        let rate = serviceCharges?.[0]?.Rate;

                                        if (drawdownPriceLockModel?.UsePriceLock &&
                                            drawdownPriceLockModel?.AppliedRate > 0 &&
                                            drawdownPriceLockModel?.AppliedRate < rate) {
                                            rate = drawdownPriceLockModel?.AppliedRate;
                                        }

                                        this.onDataChange(
                                            onChange,
                                            { DrawdownModel: { ...d, DrawdownPriceLockPercentage: rate } },
                                            data,
                                            "Contribution")
                                    });
                                });
                            } else {
                                this.onDataChange(onChange, { DrawdownModel: d }, data, "Contribution");
                            }
                            this.handleAdviceGiven(d?.InvestmentPathwayAnswers?.PersonalRecommendation ?? false);
                        }
                        }
                        subaccountHierarchyId={getQueryParameters()["subaccounthierarchyid"]}
                        instructionOwnerHierarchyId={data?.Contribution?.HierarchyId}
                    />
                    <PreADayPensionDetails {...this.getComponentProps(data, onChange)} />
                    {data?.Contribution?.DrawdownModel?.PreADay == false && (
                        <>
                            <PensionProtection
                                {...this.props}
                                onRef={(ref) => this.appendChild(ref)}
                                data={data?.Contribution}
                                onChange={(v) => this.onDataChange(onChange, v, data, "Contribution")}
                                process={ProcessType.TakePensionBenefits}
                                doCalculation={() => this.doCalculation()}
                            />
                            <ProtectionInformation
                                {...this.getComponentProps(data, onChange)}
                                process={ProcessType.TakePensionBenefits}
                                pensionProtection={data?.Contribution?.PensionProtection}
                            />

                            {data?.Contribution?.DrawdownModel?.PensionOption != PensionOption.UFPLS && (
                                <InvestmentPathSelection
                                    onRef={(ref) => this.appendChild(ref)}
                                    data={data?.Contribution?.DrawdownModel?.InvestmentPathwayAnswers}
                                    activityType={data?.ActivityType}
                                    isFirstCrystallisation={!isNotFirstCrystallisation}
                                    modelData={data?.Contribution?.DrawdownModel}
                                    toggleSwitchInvestments={(v) => {
                                        this.onDataChange(
                                            (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                                            { SwitchInvestments: v },
                                            data.Contribution,
                                            "DrawdownModel"
                                        );
                                    }
                                    }
                                    onChange={(v) => {
                                        this.onDataChange(
                                            (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                                            { InvestmentPathwayAnswers: v },
                                            data.Contribution,
                                            "DrawdownModel"
                                        );
                                        this.onDataChange(
                                            (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                                            { AdviceGiven: v.PersonalRecommendation },
                                            data.Contribution,
                                            "FinancialAdvice"
                                        );
                                        this.handleAdviceGiven(v.PersonalRecommendation);
                                    }}
                                    hardBlockforAdviserUser={this.state.userInfo?.IsAdviser && !this.state.hasDrawdownArrangement}
                                    hasOuterRingAssets={hasOuterRingAssets}
                                />
                            )}

                            <hr />

                            {data?.Contribution?.DrawdownModel?.PensionOption != PensionOption.UFPLS && (
                                <DrawdownTypeOption
                                    isImmediateTaxFreeLumpSum={
                                        !CommonHelper.isNullOrEmpty(
                                            data?.Contribution?.DrawdownModel?.ImmediateTaxFreeCashRequestId
                                        )
                                    }
                                    originType={
                                        this.state.originType ||
                                        PensionBenefitsInstructionStore.getData()?.Contribution?.DrawdownModel
                                            ?.DrawdownType
                                    }
                                    {...this.getComponentProps(data, onChange)}
                                    pensionProtection={data?.Contribution?.PensionProtection}
                                    activityType={data?.ActivityType}
                                    onChange={(v) => {
                                        if (v.DrawdownType == DrawdownType.Flexible) {
                                            this.getDrawdownIncomeReviewDetails();
                                        }
                                        this.setState({
                                            originType: this.props.data.Contribution?.DrawdownModel?.DrawdownType,
                                        });
                                        this.onDataChange(
                                            (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                                            { DrawdownType: v.DrawdownType },
                                            data.Contribution,
                                            "DrawdownModel"
                                        );
                                    }}
                                    PersonalRecommendation={
                                        data?.Contribution?.DrawdownModel?.InvestmentPathwayAnswers
                                            ?.PersonalRecommendation ?? data?.Contribution?.FinancialAdvice?.AdviceGiven
                                    }
                                    canCreateRegularCrystallisation={pensionSubAccountSettings.StandardRegular}
                                />
                            )}
                        </>
                    )}

                    {data?.Contribution?.DrawdownModel?.PreADay == false && (
                        <>
                            {isRegualr(data?.Contribution?.DrawdownModel) &&
                                data?.Contribution?.DrawdownModel?.PensionOption != PensionOption.UFPLS && (
                                    <RegularCrystallisation
                                        doCalculation={() => this.doCalculation()}
                                        {...this.getComponentProps(data, onChange)}
                                        process={ProcessType.TakePensionBenefits}
                                        hierarchyId={getQueryParameters()["subaccounthierarchyid"]}
                                        minimumDate={
                                            this.state.isDisinvest
                                                ? this.state.minimumDate_DisinvestNeed
                                                : this.state.minimumDate_DisinvestNoNeed
                                        }
                                    />
                                )}
                            {isCappedOrFlexIOrUFPLS(data?.Contribution?.DrawdownModel) && (
                                <CrystallisationDetailsSection
                                    isImmediateTaxFreeLumpSum={
                                        !CommonHelper.isNullOrEmpty(
                                            data?.Contribution?.DrawdownModel?.ImmediateTaxFreeCashRequestId
                                        )
                                    }
                                    cashInstrmentProductId={data?.CashInstrument?.ProductId || 0}
                                    doCalculation={() => this.doCalculation()}
                                    modelData={null}
                                    assets={this.state.assets}
                                    processType={ProcessType.TakePensionBenefits}
                                    {...this.getComponentProps(data, onChange)}
                                    pensionProtection={data?.Contribution?.PensionProtection}
                                />
                            )}
                            {(data?.Contribution?.DrawdownModel?.AllowanceDetails?.HasOffPlatformBcePriorApril2024 && !data?.Contribution?.DrawdownModel?.AllowanceDetails?.AwareOfBCEAmounts) &&
                                !hasPrimaryProtection(data?.Contribution?.PensionProtection) && !hasEnhancedProtectionWithPclsProtection(data?.Contribution?.PensionProtection) && (
                                    <>
                                        <LTABreakdownDetails
                                            doCalculation={() => this.doCalculation()}
                                            {...this.getComponentProps(data, onChange)}
                                            process={ProcessType.TakePensionBenefits}
                                            lessThan75={ageLessThan75}
                                            hasEnhancedPensionProtection={hasEnhancedPensionProtection(data?.Contribution)}
                                        />
                                    </>
                                )}
                            <AllowanceDetails
                                doCalculation={() => this.doCalculation()}
                                {...this.getComponentProps(data, onChange)}
                                pensionProtection={data?.Contribution?.PensionProtection}
                                hasEnhancedPensionProtection={hasEnhancedPensionProtection(data?.Contribution)}
                                process={ProcessType.TakePensionBenefits}
                            />
                           <div className="mt-30">
                                <TaxFreeLumpSumPayment
                                    doCalculation={() => this.doCalculation()}
                                    process={ProcessType.TakePensionBenefits}
                                    pensionProtection={data?.Contribution?.PensionProtection}
                                    {...this.getComponentProps(data, onChange)}
                                    lessThan75={ageLessThan75}
                                    hideSeparator={true}
                                    hasEnhancedPensionProtection={hasEnhancedPensionProtection(data?.Contribution)}
                                />
                            </div>
                             <PCLSSection
                                {...this.getComponentProps(data, onChange)}
                                data={data.Contribution.DrawdownModel}
                                hidePCLSSection
                            />

                            <hr className="mb-20"/>

                            {data?.Contribution?.DrawdownModel?.DrawdownType !== DrawdownType.Regular &&
                                data?.Contribution?.DrawdownModel?.PensionOption != PensionOption.UFPLS && (
                                    <DIAC
                                        {...this.getComponentProps(data, onChange)}
                                        modelData={data?.Contribution}
                                        existingAccount={true}
                                    />
                                )}
                            <OAC
                                readonly={true}
                                type={SubAccountType.Npr}
                                onChange={(v) => { }}
                                data={{
                                    OngoingAdviceCharge:
                                        data?.Contribution?.OngoingAdviceCharge,
                                }}
                                onRef={(ref) => this.appendChild(ref)}
                            />
                            <ChargesOnIllustration {...this.getProps("Contribution")} />
                            <hr />
                            <DrawdownPriceLock
                                {...this.getComponentProps(data, onChange)}
                                subaccountHierarchyId={getQueryParameters()["subaccounthierarchyid"]}
                                totalPea={this.getTotalPea(data?.Contribution?.DrawdownModel)}
                            />
                            {showChooseAssetstoSell(
                                data?.Contribution?.DrawdownModel,
                                ChooseAssetsToSellFor.Drawdown
                            ) && (
                                    <>
                                        <ChooseAssetsToSell
                                            {...this.getComponentProps(data, onChange)}
                                            tableKey={TableKeys.PensionCommencementLumpSumAllocations}
                                            assets={this.state.assets}
                                            isAcrossAllAssets={this.state.isAcrossAllAssets}
                                            setIsAcrossAllAssets={(v) => this.setState({ isAcrossAllAssets: v })}
                                        />
                                        {this.showChooseAssetsToSellTable() && (
                                            <ChooseAssetsToSellTable
                                                data={
                                                    data?.Contribution?.DrawdownModel
                                                        ?.PensionCommencementLumpSumAllocations || []
                                                }
                                                tableData={this.state.assets}
                                                modelData={data?.Contribution?.DrawdownModel}
                                                onRef={(ref) => this.appendChild(ref)}
                                                showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                                                onChange={(v) => {
                                                    this.onDataChange(
                                                        (changes) =>
                                                            this.onDataChange(onChange, changes, data, "Contribution"),
                                                        { PensionCommencementLumpSumAllocations: v },
                                                        data.Contribution,
                                                        "DrawdownModel"
                                                    );
                                                    this.setIsDisinvest();
                                                }}
                                                processType={ProcessType.TakePensionBenefits}
                                                reason={ChooseAssetsToSellFor.Drawdown}
                                                isAcrossAllAssets={data?.Contribution?.DrawdownModel?.IsAcrossAllAssets}
                                                disableOffPlatform={true}
                                            />
                                        )}
                                    </>
                                )}

                            {data?.Contribution?.DrawdownModel?.PensionOption === PensionOption.UFPLS && (
                                <>
                                    <CalculateEstimatedPaye query={this.getCalculateEstimatedPayeQueries()} />
                                    <hr />
                                    <IncomeBankDetails
                                        data={data?.Contribution?.DrawdownModel?.Income?.IncomePaymentAllocations || []}
                                        onChange={(value) => {
                                            onChange(
                                                setValueByKey(
                                                    data,
                                                    "Contribution.DrawdownModel.Income.IncomePaymentAllocations",
                                                    value
                                                )
                                            );
                                        }}
                                        onPaymentMethodChange={(value) => {
                                            if (data.Contribution?.DrawdownModel?.Income?.PaymentMethod) {
                                                data.Contribution.DrawdownModel.Income.PaymentMethod = value;
                                            }
                                            onChange(data);
                                        }}
                                        showErrorMsgPopUp={(msg, isShow) => this.props.showErrorMsgPopUp(msg, isShow)}
                                        onRef={(ref) => this.appendChild(ref)}
                                        allBankAccounts={data?.AllBankAccounts}
                                        showPropotionOfIncome={false}
                                        bankAccountInstructions={data?.BankAccountInstructions}
                                        onChangeBankAccountInstructions={(changes) => {
                                            this.onDataChange(onChange, changes, data, "BankAccountInstructions");
                                        }}
                                        OwnerHierarchyId={data?.OwnerHierarchyId}
                                        showPropotionOfPcls={true}
                                    />
                                </>
                            )}
                            <hr />
                            {showSwitchInvestments(data?.Contribution?.DrawdownModel, this.state.assetsToSwitchTable) && (
                                <SwitchInvestments
                                    data={data}
                                    onChange={(v) => {
                                        this.onDataChange(
                                            (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                                            v,
                                            data.Contribution,
                                            "DrawdownModel"
                                        );
                                    }}
                                    onRef={(ref) => this.appendChild(ref)}
                                    showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                                    isReview={this.props.isReview}
                                    assets={this.state.assets}
                                    assetsTable={this.state.assetsToSwitchTable}
                                    disableOffplatform={true}
                                />
                            )}
                        </>
                    )}
                </>
            </PartLoading>
        );
    }
}
